import { cn } from "@/lib/utils";

/* Page layout — used by `<Page>`, `<PageToolbar>`, `<PageScrollBody>` and
 * pages that haven't migrated to the primitive yet. */

export const PAGE_GUTTER_X = "px-8";

export const pageToolbarClasses = (className?: string) =>
  cn("shrink-0 border-b", PAGE_GUTTER_X, "py-4", className);

export const pageScrollBodyClasses = (className?: string) =>
  cn(
    "relative min-h-0 flex-1 overflow-y-auto",
    PAGE_GUTTER_X,
    "py-6",
    className,
  );

export const PAGE_CONTENT_STACK =
  "mx-auto flex w-full max-w-6xl flex-col gap-6";

export const PAGE_SECTION_GAP = "gap-10";

export const PAGE_GRID_GAP = "gap-4";

/** Centers an empty state in the remaining flex pane (Automations, Tables, …). */
export const EMPTY_STATE_PANE_CENTER =
  "flex min-h-0 w-full flex-1 flex-col items-center justify-center";
